<template>
  <div class="aside-left-wrap">
    <div class="top">
      <div class="avatar-box">
        <div class="avatar" :style="{ backgroundImage: `url(${user.portrait})` }"></div>
      </div>
      <span class="name">{{ user.userName }}</span>
      <div class="opts">
        <el-tooltip :content="$t('btn_resetPassword')">
          <div class="item" @click="resetPassword">
            <i class="el-icon-lock"></i>
          </div>
        </el-tooltip>
        <el-tooltip :content="$t('configTimeout')">
          <div class="item" @click="configTimeout">
            <i class="el-icon-setting"></i>
          </div>
        </el-tooltip>
        <el-tooltip :content="$t('login_out')">
          <div class="item" @click="loginOut">
            <svg-icon icon-name="log_out" icon-color="#1e49e2" :size="12"
              style="position: relative; bottom: 1px;"></svg-icon>
          </div>
        </el-tooltip>
      </div>
    </div>
    <div class="mid">
      <div class="__title">
        <!-- <svg-icon icon-name="home_workbench" :size="18"></svg-icon> -->
        <img src="@/assets/img/home_workbench.svg" alt="">
        {{ $t('workbench') }}
      </div>
      <div class="__content">
        <site-list :siteIds="siteIds" />
      </div>
    </div>
    <div class="bottom">
      <div class="connect-us">
        <img src="@/assets/img/Cantact_KCC_Team.png">
        <a target="_top" href="mailto:cnfmkpmgclicbt@kpmg.com">{{ $t('newsMgt.contactTeam') }}</a>
      </div>
      <div class="videos">
        <img src="@/assets/img/introduction_video_bg.png">
        <div class="_r">
          <div class="_t">
            {{ $t('newsMgt.videoList.introductionClient') }}
          </div>
          <a @click="renderVideo('en')">{{ $t('newsMgt.videoList.en') }}</a>
          <a @click="renderVideo('cn')">{{ $t('newsMgt.videoList.cn') }}</a>
          <a @click="renderVideo('yueyu')">{{ $t('newsMgt.videoList.yueyu') }}</a>
        </div>
      </div>
    </div>
    <!--    配置超时时间---------start------>
    <el-dialog :title="$t('configTimeoutDialogTitle')" :visible.sync="timeoutVisible" width="20%" :show-close="false">
      <div class="center">
        <el-input-number v-model="outTime" :precision="1" :step="0.5" :max="8" :min="0.5"></el-input-number>
        {{ $t('hour') }}
        <div class="tip" style="color:#fd349c; text-align: left;">
          <i class="el-icon-info"></i>
          {{ $t('outTimeTips') }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="() => {timeoutVisible = false; }">{{ $t('btn_cancel') }}</el-button> -->
        <el-button type="primary" @click="setOutTime">{{ $t('btn_confirm') }}</el-button>
      </span>
    </el-dialog>
    <!--    配置超时时间---------end------>
    <short-videos v-if="videoListShow" :onCancel="toogleVideoShow" />
  </div>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import SvgIcon from "@/components/svgIcon/index";
import ShortVideos from '@/components/common/ShortVideos.vue'
import Vue from 'vue'
import SiteList from './SiteList.vue'

export default {
  name: 'AsideLeft',
  components: { SvgIcon, SiteList, ShortVideos },
  data() {
    return {
      user: {},
      timeoutVisible: false,
      outTime: 0.5,
      videoListShow: false,
    }
  },
  props: {
    siteIds: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('common', {
      getUser: 'getUser'
    }),
  },
  mounted() {
    this.user = { ...this.getUser }
    this.user.portrait = this.user.portrait ? `data:image/*;base64,${this.user.portrait}` : require('@/assets/img/default-avatar.png')
    this.getOutTime()
    Vue.prototype.$showVideoDialog = () => {
      this.videoListShow = true
    }
    Vue.prototype.$hideVideoDialog = () => {
      this.videoListShow = false
    }
  },
  methods: {
    toogleVideoShow() {
      this.videoListShow = !this.videoListShow
    },
    resetPassword() {
      this.$router.push('/changePassword')
    },
    configTimeout() {
      this.timeoutVisible = true
    },
    loginOut() {
      API.common
        .logout({ param: this.user.userAccount })
        .then(res => {
          sessionStorage.removeItem('JSESSIONID')
          localStorage.removeItem('JSESSIONID')
          sessionStorage.removeItem('siteClassification')
          this.$store.commit('common/setUser', {})
          this.$store.commit('common/setSite', {})
          this.$store.commit('common/setEntity', {})
          this.$router.push('/login')
        })
        .catch(err => {
        })
        .finally(() => {
        })
    },
    async getOutTime() {
      const res = await API.pbc.getConfig()
      if (res.code === '1') {
        this.outTime = res.data.sessionTime ? res.data.sessionTime / 60 : 0.5
      } else {
        this.$message.error(this.$t(res.code))
      }
    },
    async setOutTime() {
      const res = await API.pbc.setTime({ param: (this.outTime * 60).toString() })
      if (res.code === '1') {
        this.$message.success(this.$t('msg_success'))
      } else {
        this.$message.error(this.$t(res.code))
      }
      this.timeoutVisible = false
    },
    renderVideo(lang) {
        this.$showVideoDialog()
        localStorage.setItem('homepage_video_close_all', 1)
        this.$nextTick(() => {
            this.$chooseVideo(1, false, lang)
        })
    },
  }
}
</script>

<style scoped>
.aside-left-wrap {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  position: relative;
}

.top {
  height: 172PX;
  flex-shrink: 0;
}

.mid {
  height: calc(100% - 172PX);
  padding-bottom: 177PX;
}

.mid .__title {
  height: 40PX;
  font-size: 18PX;
  font-weight: 600;
  padding: 0 12PX;
  display: flex;
  align-items: center;
}

.mid .__title img {
  width: 20PX;
  margin-right: 5PX;
  position: relative;
  top: 2px;
}

.mid .__content {
  height: calc(100% - 40PX);
}

.mid .__content .item {
  display: flex;
  align-items: center;
}

.bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 167PX;
  flex-shrink: 0;
}

.top {
  border-bottom: 1px dashed #ebebeb;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20PX 0 15PX 0;
}

.top .avatar-box {
  width: 70PX;
  height: 70PX;
  border-radius: 10px;
  background: url(~@/assets/img/avatar_bg.png) no-repeat center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.top .avatar-box .avatar {
  width: 45PX;
  height: 45PX;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
}

.top .name {
  font-size: 14PX;
  font-weight: 600;
  margin: 10PX 0;
}

.top .opts {
  display: flex;
  width: 50%;
  justify-content: space-evenly;
}

.top .opts .item {
  border-radius: 5px;
  width: 26PX;
  height: 26PX;
  line-height: 26PX;
  text-align: center;
  background-color: #1e49e210;
  color: #1e49e2;
  cursor: pointer;
  font-size: 14PX;
}

.bottom {
  padding: 12PX;
  width: 100%;
  border-top: 1px dashed #ebebeb;
}

.bottom .connect-us {
  display: flex;
  background-color: #1AE0D620;
  padding: 12PX;
  border-radius: 6px;
}

.connect-us img {
  width: 40PX;
  height: 40PX;
  flex-shrink: 0;
  margin-right: 10PX;
}

.connect-us a {
  width: 100%;
  display: flex;
  align-items: center;
  color: #111;
  font-weight: 600;
  font-size: 14PX;
}

.bottom .videos {
  display: flex;
  background-color: #F56C6C22;
  padding: 12PX;
  border-radius: 6px;
  margin-top: 15PX;
}

.videos img {
  width: 40PX;
  height: 40PX;
  flex-shrink: 0;
  margin-right: 10PX;
}

.videos ._r {
  width: 100%;
  font-size: 14PX;
}

.videos ._r a {
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
  margin-right: 10px;
}

.videos ._r ._t {
  color: #111;
  font-weight: 600;
}
</style>